export enum IdentityValidationDocumentName {
  PICTURE = 'PICTURE',
  IDENTITY_DOCUMENT = 'IDENTITY_DOCUMENT',
  IDENTITY_DOCUMENT_2 = 'IDENTITY_DOCUMENT_2',
}

export enum FileExtension {
  PDF = 'PDF',
  PNG = 'PNG',
  JPG = 'JPG',
}

export const getIdentityValidationDocumentName = (type: string) => {
  const values = Object.values(IdentityValidationDocumentName);
  const found = values.find((value) => value === type);
  if (found) {
    return found;
  }
  throw Error('Unsuported identity validation document name');
};

export const getFileExtension = (extension: string) => {
  const values = Object.values(FileExtension);
  const found = values.find((value) => extension.includes(value.toLocaleLowerCase()));
  if (found) {
    return found;
  } else if (extension.includes('jpeg')) {
    return FileExtension.JPG;
  }
  throw Error('Unsuported file extension');
};
